webpackJsonp([186513491357691],{

/***/ 788:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Reducers = __webpack_require__(57);
	
	var _Reducers2 = _interopRequireDefault(_Reducers);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Reducers2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'find'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This blueprint...'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Example usage is below:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      const state = lore.store.getState();\n      const query = {\n        where: {\n          user: 1\n        }\n      }\n      const key = JSON.stringify(query);\n      const tweets = state.tweet.find[key];\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Blueprint'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import _ from \'lodash\';\n      import { ActionTypes } from \'lore-utils\';\n\n      function mergeDataAndIntersectWithDictionaryKeys(oldData, newData, dictionary) {\n        const ids = _.map(oldData, \'id\');\n        const newIds = _.map(newData, \'id\');\n        const combinedIds = _.union(ids, newIds);\n        const dictionaryKeys = _.keys(dictionary);\n\n        // If any ids are Numbers, convert them to Strings so we can compare equality\n        // with the dictionary keys\n        const combinedIdsAsStrings = combinedIds.map(function(id) {\n          return id.toString();\n        });\n\n        const idsInDictionary = _.intersection(combinedIdsAsStrings, dictionaryKeys);\n        return idsInDictionary.map(function(id) {\n          return dictionary[id];\n        });\n      }\n\n      export default function(modelName) {\n        const initialState = {};\n        // const EMPTY_QUERY_KEY = JSON.stringify({});\n\n        return function find(state, action, options) {\n          state = state || initialState;\n          let nextState = _.assign({}, state);\n          const byId = options.nextState.byId;\n          const byCid = options.nextState.byCid;\n\n          switch (action.type) {\n            case ActionTypes.fetchPlural(modelName): {\n              const query = JSON.stringify(action.query);\n              nextState[query] = nextState[query] || {};\n              nextState[query] = _.assign({}, action.payload, {\n                data: mergeDataAndIntersectWithDictionaryKeys(\n                  nextState[query].data,\n                  action.payload.data,\n                  byId\n                )\n              });\n              return nextState;\n            }\n\n            case ActionTypes.refetchPlural(modelName): {\n              const query = JSON.stringify(action.query);\n              nextState[query] = nextState[query] || {};\n              nextState[query] = _.assign({}, action.payload, {\n                data: mergeDataAndIntersectWithDictionaryKeys(\n                  [],\n                  action.payload.data,\n                  byId\n                )\n              });\n              return nextState;\n            }\n\n            case ActionTypes.update(modelName): {\n              nextState = _.mapValues(nextState, function(collection, key) {\n                collection.data = collection.data.map(function(datum) {\n                  if (datum.id === action.payload.id) {\n                    return action.payload;\n                  }\n                  return datum;\n                });\n\n                return collection;\n              });\n              return nextState;\n            }\n\n            case ActionTypes.remove(modelName): {\n              nextState = _.mapValues(nextState, function(collection, key) {\n                collection.data = collection.data.map(function(datum) {\n                  if (datum.id === action.payload.id) {\n                    return action.payload;\n                  }\n                  return datum;\n                });\n\n                return collection;\n              });\n              return nextState;\n            }\n\n            default:\n              return nextState;\n          }\n        };\n      }\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-reducers-find-js-c8df761e5325c06513e9.js